/** Degradado ambiental (verde + azul marca), igual que el hero de Nosotros. */
export default function SectionAmbientGradient({ className = 'opacity-40' }) {
  return (
    <div
      className={`pointer-events-none absolute inset-0 ${className}`}
      aria-hidden
      style={{
        background:
          'radial-gradient(ellipse 80% 60% at 20% 0%, rgba(26,203,18,0.18), transparent 55%), radial-gradient(ellipse 70% 50% at 100% 50%, rgba(10,17,138,0.35), transparent 50%)',
      }}
    />
  );
}
